import { listLabel } from "../table/columnDefs";

export const getFilterValue = (filters, id) => filters.find((filter) => filter.id === id)?.value;

export const isEmptyFilterValue = (value) => {
    if (value === undefined || value === null) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === "string") return !value.trim();
    if (typeof value === "object" && ("from" in value || "to" in value)) return !value.from && !value.to;
    return false;
};

export const setFilterValue = (filters, id, value) => {
    const rest = filters.filter((filter) => filter.id !== id);
    return isEmptyFilterValue(value) ? rest : [...rest, { id, value }];
};

export const sameSet = (a = [], b = []) => a.length === b.length && a.every((value) => b.includes(value));

const formatDay = (day) => day.split("-").reverse().join("/");

export const describeFilterValue = (config, value) => {
    if (Array.isArray(value)) {
        const names = value.map((key) => listLabel(config, key));
        return names.length <= 2 ? names.join(", ") : `${names[0]} +${names.length - 1}`;
    }
    if (value && typeof value === "object" && ("from" in value || "to" in value)) {
        if (value.from && value.to) return `${formatDay(value.from)} a ${formatDay(value.to)}`;
        return value.from ? `a partir de ${formatDay(value.from)}` : `até ${formatDay(value.to)}`;
    }
    return `contém "${value}"`;
};

/** Itens da barra de filtros ativos, derivados do estado da tabela. */
export const buildActiveFilterItems = (table, { exclude = [], describe = {} } = {}) =>
    table
        .getState()
        .columnFilters.filter((filter) => !exclude.includes(filter.id))
        .map((filter) => {
            const column = table.getColumn(filter.id);
            if (!column) return null;
            const config = column.columnDef.meta?.config ?? {};
            const text = describe[filter.id] ? describe[filter.id](filter.value) : describeFilterValue(config, filter.value);
            return {
                id: filter.id,
                label: `${config.header || filter.id}: ${text}`,
                column,
                onRemove: () => column.setFilterValue(undefined),
            };
        })
        .filter(Boolean);
